import { useEffect } from 'react';
import {
  useCreateDrugAccRecordMutation,
  useDrugKitCreateNotesMutation,
  useGetDrugAccountRecordMutation,
  useGetIPNamesQuery,
  useGetSiteInfoMutation,
  useLazyGetDrugKitAllNotesQuery,
  useUpdateDrugKitDocMutation,
  useUpdateDrugKitRecordsMutation
} from 'src/services/DrugAccountability';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { updateUserAccess } from 'src/util/util';

export const useDrugAccountability = () => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const dispatch = useAppDispatch();

  const [getSiteInfoQueryData, { data: siteInfoQueryData, error: getSiteInfoError }] = useGetSiteInfoMutation();

  const [
    getDrugAccountRecord,
    { isLoading: getDrugAccountRecordLoading, data: getDrugAccountRecordData, error: getDrugAccountRecordError }
  ] = useGetDrugAccountRecordMutation();

  const [createDrugAccRecord, { error: createDrugAccRecordError, isSuccess: createDrugAccRecordSuccess }] =
    useCreateDrugAccRecordMutation();

  const [
    updateDrugKitRecords,
    { data: updateDrugAccRecordData, error: updateDrugAccRecordError, isSuccess: updateDrugAccRecordSucess }
  ] = useUpdateDrugKitRecordsMutation();

  const [updateDrugKitDoc, { data: updateDrugKitDocData }] = useUpdateDrugKitDocMutation();

  const [getDrugKitAllNotes, { data: drugKitAllNotesData, error: drugKitAllNotesError }] =
    useLazyGetDrugKitAllNotesQuery();

  const [drugKitCreateNotes, { data: createNotesData, error: createNotesError }] = useDrugKitCreateNotesMutation();

  const {
    data: getIpData,
    error: getIPError,
    refetch: getIPQueryData
  } = useGetIPNamesQuery({
    study_id: studyId,
    site_id: siteId,
    country,
    application
  });
  useEffect(() => {
    if (createDrugAccRecordError || getSiteInfoError) {
      const errorData: any = createDrugAccRecordError || getSiteInfoError;
      if (errorData?.status === 403) {
        dispatch(setMessage({ msgDetails: `${errorData?.status} : Forbbiden Access`, severity: 'error' }));
      } else if (errorData?.status === 404) {
        dispatch(
          setMessage({ msgDetails: `${errorData?.data?.context?.message} : Forbbiden Access`, severity: 'error' })
        );
      } else if (errorData?.status === 401) {
        dispatch(setMessage({ msgDetails: `${errorData?.data?.detail} : Refresh the screen`, severity: 'error' }));
      } else if (errorData?.status === 500 && errorData?.data?.context?.message === 'Data already Exist') {
        dispatch(setMessage({ msgDetails: `Duplicate Entry`, severity: 'error' }));
      } else {
        updateUserAccess(createDrugAccRecordError || getSiteInfoError, dispatch);
      }
    }
  }, [getSiteInfoError, createDrugAccRecordError]);

  useEffect(() => {
    if (createDrugAccRecordSuccess) {
      dispatch(setMessage({ msgDetails: 'New Kit created successfully', severity: 'success' }));
    }
  }, [createDrugAccRecordSuccess]);

  useEffect(() => {
    if (updateDrugAccRecordSucess) {
      dispatch(setMessage({ msgDetails: 'Data updated successfully', severity: 'success' }));
    }
  }, [updateDrugAccRecordSucess]);

  return {
    siteInfoQueryData,
    getSiteInfoError,
    getSiteInfoQueryData,
    createDrugAccRecord,
    getDrugAccountRecord,
    getDrugAccountRecordData,
    getDrugAccountRecordError,
    getDrugAccountRecordLoading,
    updateDrugAccRecordData,
    updateDrugKitRecords,
    updateDrugKitDoc,
    updateDrugKitDocData,
    updateDrugAccRecordError,
    drugKitCreateNotes,
    createNotesData,
    createNotesError,
    getDrugKitAllNotes,
    drugKitAllNotesData,
    drugKitAllNotesError,
    getIPQueryData,
    getIpData,
    getIPError
  };
};
